<template>
  <fragment>
    <div class="account-nav-desktop">
      <component
        v-for="item in nav"
        :is="activeLink(item.link) ? 'div' : 'a'"
        :key="item.label"
        :href="item.link"
        class="account-nav-link"
        :class="{
          active: activeLink(item.link),
        }"
      >
        {{ item.label }}
      </component>
      <button
        @click="signOut"
        role="link"
        class="account-nav-link sign-out-button"
      >
        Sign Out
      </button>
    </div>

    <div class="account-nav-mobile">
      <div class="f aic jcc" @click="toggleDropdown">
        <span class="account-nav-mobile-active-link">{{ currentLink }}</span>
        <span class="f" style="margin-left: 8px">
          <svg-caret-down></svg-caret-down>
        </span>
      </div>

      <div
        class="account-nav-mobile-dropdown"
        :class="{ open }"
        v-click-outside="handleOutsideClick"
        @click="toggleDropdown"
      >
        <component
          v-for="(item, index) in mobileNav"
          :is="activeLink(item.link) ? 'div' : 'a'"
          :key="item.label"
          :href="item.link"
          class="account-nav-link-mobile"
          :class="{
            active: activeLink(item.link),
          }"
        >
          <div class="f aic jcc x">
            <span>
              {{ item.label }}
            </span>

            <span
              class="f"
              style="margin-left: 8px; transform: rotate(180deg)"
              v-if="index === 0"
            >
              <svg-caret-down></svg-caret-down>
            </span>
          </div>
        </component>
        <button
          @click="signOut"
          role="link"
          class="account-nav-link-mobile sign-out-button f aic jcc x"
        >
          Sign Out
        </button>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: "account-nav",
  data() {
    return {
      nav: [
        { label: "orders", link: "/account" },
        { label: "addresses", link: "/account/addresses" },
        { label: "dirty dishes club", link: "/pages/dirty-dishes-club" },
      ],
      open: false,
    };
  },
  methods: {
    activeLink(path) {
      if (window.location.pathname === path) {
        return true;
      }

      return false;
    },
    toggleDropdown() {
      this.open = !this.open;
    },
    handleOutsideClick() {
      if (!this.open) return;
      this.open = false;
    },
    async signOut() {
      try {
        const event = "submit : logout";
        const user = window.theme.customer;
        const eventData = {
          "customer - logged in": user.isLoggedIn,
          "customer - shopify id": user.id,
          "customer - email": user.email ? user.email : "",
        };

        if (typeof amplitude !== "undefined") {
          await amplitude.getInstance().logEvent(event, eventData);
        }
      } catch (e) {
        console.error(e);
      }
      window.location.href = "/account/logout";
    },
  },
  computed: {
    currentLink() {
      const currentPath = this.nav.find(
        ({ link }) => link === window.location.pathname
      );
      return currentPath ? currentPath.label : "";
    },
    mobileNav() {
      const navCopy = this.nav.slice();
      const mobileNav = navCopy.sort((a, b) => {
        if (a.link === window.location.pathname) {
          return -1;
        }

        return 1;
      });

      return mobileNav;
    },
  },
};
</script>
